import z from 'zod';

export type MenuPlannerState = 'Editing' | 'Published' | 'Closed' | 'Archived' | 'Inconsistent';

export const MenuPlannerStateSchema: z.ZodType<MenuPlannerState> = z.enum([
	'Editing',
	'Published',
	'Closed',
	'Archived',
	'Inconsistent',
]);
